/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Type_VideoInputs */

const en_media_type_video = /** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Video`)
};

const id_media_type_video = /** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Premium`)
};

/** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */
const es_media_type_video = en_media_type_video;

/** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */
const fr_media_type_video = en_media_type_video;

/** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */
const de_media_type_video = en_media_type_video;

/** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */
const ja_media_type_video = en_media_type_video;

/** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */
const zh_media_type_video = en_media_type_video;

/** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */
const ar_media_type_video = en_media_type_video;

/** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */
const it_media_type_video = en_media_type_video;

/** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */
const ru_media_type_video = en_media_type_video;

/** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */
const pt_media_type_video = en_media_type_video;

/** @type {(inputs: Media_Type_VideoInputs) => LocalizedString} */
const ko_media_type_video = en_media_type_video;

/**
* | output |
* | --- |
* | "Premium Video" |
*
* @param {Media_Type_VideoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const media_type_video = /** @type {((inputs?: Media_Type_VideoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Type_VideoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_media_type_video(inputs)
	if (locale === "es") return es_media_type_video(inputs)
	if (locale === "fr") return fr_media_type_video(inputs)
	if (locale === "de") return de_media_type_video(inputs)
	if (locale === "ja") return ja_media_type_video(inputs)
	if (locale === "zh") return zh_media_type_video(inputs)
	if (locale === "ar") return ar_media_type_video(inputs)
	if (locale === "id") return id_media_type_video(inputs)
	if (locale === "it") return it_media_type_video(inputs)
	if (locale === "ru") return ru_media_type_video(inputs)
	if (locale === "pt") return pt_media_type_video(inputs)
	return ko_media_type_video(inputs)
});